<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-2">
        {{ $t("reserved") }} {{ $t("Seats") }}
      </div>
      <div class="mt-2 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-5 align-self-center mb-2">
            <div class="dropdown-curve-container mr-2">
              <label :class="getSelectedCinema ? 'shift-up' : ''">{{
                $tc("cinema", 1)
              }}</label>
              <b-dropdown
                :text="getSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="onSelectCinema(dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <button @click="onClearDate" class="btn-clearDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  :disabled-dates="disabledDates"
                  v-model="showdate"
                  :typeable="true"
                ></Datepicker>
                <label :class="showdate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-xl-2 align-self-center mb-2">
            <button @click="onFetchData" class="btn-blue-lg w-100">
              {{ $tc("fetch") }}
            </button>
          </div>
          <div class="col-lg-2 col-xl-2 align-self-center mb-2">
            <button
              v-if="$can('create', 'Reserve Seats')"
              @click="Add"
              class="btn-blue-lg w-100"
            >
              {{ $tc("add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table mb-2" border="1">
          <thead class>
            <tr class="bg-lightgrey">
              <th>{{ $tc("reservation", 1) }} {{ $t("id") }}</th>
              <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
              <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
              <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
              <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
              <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
              <th>{{ $tc("customer", 1) }}</th>
              <th>{{ $tc("remark", 1) }}</th>
              <th>{{ $tc("action", 1) }}</th>
            </tr>
          </thead>
          <tbody v-if="getReservationList.length > 0" class="sph-report">
            <tr
              v-for="(transaction, transactionIndex) in getReservationList"
              :key="transactionIndex"
              class="light_grey_back"
            >
              <td style="text-align: right">
                {{ transaction.reservation_id }}
                <img
                  @click="onCopyId(transaction.reservation_id)"
                  src="@/assets/img/icons/copy_image_icon.png"
                  width="15px"
                  height="15px"
                  class="ml-2"
                />
              </td>
              <td style="text-align: left">{{ transaction.movie_title }}</td>
              <td style="text-align: right">
                {{ transaction.ss_actual_start_date | dateparse }}
              </td>
              <td style="text-align: right">
                {{ transaction.ss_start_show_time }}
              </td>
              <td style="text-align: left">{{ transaction.screen_name }}</td>
              <td style="text-align: left">{{ transaction.sl_seat_name }}</td>
              <td style="text-align: left">
                {{ transaction.customer_full_name | filterNullUndefined }}
              </td>
              <td style="text-align: left">
                {{ transaction.sstr_remarks | filterNullUndefined }}
              </td>
              <td>
                <b-button
                  variant="default"
                  v-if="$can('update', 'Reserve Seats')"
                  @click="openCancelPopUp(transaction.reservation_id)"
                  class="btn-blue v-step-1"
                  >{{ $tc("Cancel") }}</b-button
                >
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
        <b-modal
          id="confirmation"
          title="Delete Unpaid Booking?"
          hide-footer
          no-close-on-backdrop
        >
          <div class="text-center pb-1">
            <p class="fs-16 mb-2">
              {{
                `Are you sure you want to release Unpaid Booking For Reservation ID ${selected_reservation_id}`
              }}
            </p>

            <button
              class="btn-outline-blue"
              @click.prevent.stop="$bvModal.hide('confirmation')"
            >
              Cancel
            </button>
            <span class="mx-1"></span>
            <button
              class="btn btn-danger btn-danger-lg px-4 fs-14"
              @click.prevent.stop="cancelUnpaidBooking"
            >
              Confirm
            </button>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import NoRecords from "@/components/Partials/NoRecords.vue";
 import moment from "moment";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      Cinemas: [],
      isRoleID: true,
      getSelectedCinema: "",
      showdate: null,
      getReservationList: [],
      cinemaId: null,
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      selected_reservation_id: "",
    };
  },
  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.cinemaId = CinemaObj.cine_id;
      this.getSelectedCinema = CinemaObj.cine_name;
      this.showdate = new Date();
      this.onFetchData();
    }
  },
  methods: {
    moment,
    cancelUnpaidBooking() {
      let payload = {
        reservation_id: this.selected_reservation_id,
      };
      ExhibitorService.CancelUnpaidBooking(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.onFetchData();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("error:", err);
        })
        .finally(() => {
          this.$bvModal.hide("confirmation");
        });
    },
    openCancelPopUp(reservation_id) {
      this.selected_reservation_id = reservation_id;
      this.$bvModal.show("confirmation");
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (cinema) {
      this.cinemaId = cinema.cine_id;
      this.getSelectedCinema = cinema.cine_name;
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onClearDate() {
      this.showdate = null;
    },
    onCopyId(id) {
      this.$copyText(id).then((e) => {
        if (e.action === "copy") {
          this.$toasted.show("Reservation Id Copied");
        } else {
          this.$toasted.show("Cannot Copy Reservation Id");
        }
      });
    },
    onFetchData() {
      this.getReservationList = [];
      let payload = {
        cinema_id: this.cinemaId,
        show_date: moment(this.showdate).format("YYYY-MM-DD HH:mm") || null,
      };
      ExhibitorService.GetReservationIds(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.getReservationList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    Add() {
      this.$router.push({
        path: "reserve-seats",
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ReserveSeatComponent/reserveSeatsList.vue